import React from 'react';
import { renderCasePlanWidget } from '@orijinworks/frontend-commons';
import { ArchivedWidgetsListRoot } from './ArchivedWidgetsList.styles';

/**
 * Standalone list of archived widgets that no longer appear inside their parent section on
 * the Archived tab. Each entry is rendered through the shared widget registry.
 */
export function ArchivedWidgetsListView({ widgets = [] }) {
  if (widgets.length === 0) {
    return null;
  }

  return (
    <ArchivedWidgetsListRoot aria-label="Archived widgets">
      {widgets.map((widget) => (
        <React.Fragment key={widget.id}>{renderCasePlanWidget(widget)}</React.Fragment>
      ))}
    </ArchivedWidgetsListRoot>
  );
}

export const ArchivedWidgetsList = React.memo(ArchivedWidgetsListView);
ArchivedWidgetsList.displayName = 'ArchivedWidgetsList';
